const EXECUTE_STATUS = Object.freeze({
    SUCCESS: 'success',
    INSUFFICIENT_CREDITS: 'insufficient_credits',
    TIMEOUT: 'timeout',
    FAILURE: 'failure'
});

const VERIFY_STATUS = Object.freeze({
    SUCCESS: 'success',
    PENDING: 'pending',
    FAILURE: 'failure'
});

export const CREDIT_API_MOCK_SCENARIOS = Object.freeze({
    success: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.SUCCESS }),
        verify: Object.freeze({ status: VERIFY_STATUS.SUCCESS })
    }),
    insufficient_credits: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.INSUFFICIENT_CREDITS }),
        verify: Object.freeze({ status: VERIFY_STATUS.FAILURE })
    }),
    timeout_verify_success: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.TIMEOUT }),
        verify: Object.freeze({ status: VERIFY_STATUS.SUCCESS })
    }),
    timeout_verify_pending: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.TIMEOUT }),
        verify: Object.freeze({ status: VERIFY_STATUS.PENDING })
    }),
    timeout_verify_failed: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.TIMEOUT }),
        verify: Object.freeze({ status: VERIFY_STATUS.FAILURE })
    }),
    execute_failed: Object.freeze({
        execute: Object.freeze({ status: EXECUTE_STATUS.FAILURE }),
        verify: Object.freeze({ status: VERIFY_STATUS.FAILURE })
    })
});

export function getCreditApiMockScenario(scenarioName = 'success') {
    return CREDIT_API_MOCK_SCENARIOS[scenarioName] || CREDIT_API_MOCK_SCENARIOS.success;
}

export { EXECUTE_STATUS, VERIFY_STATUS };
